import { Linkable } from '@/components/blocks/Linkable';
import { tileDescriptionSX, linkTitleSX } from '@/components/blocks/ProductDetails/styles/aplazo';
import { Box, Stack, Typography } from '@mui/material';
import React, { FC, Fragment } from 'react';
import { ProductDetailsDPValeDisplayModal } from './DpvaleModal';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { ShowByCondition } from '../ShowByCondition';
import { Img } from '../MaterialImage';

interface Props {
	isElectronicos?: boolean;
	orderId?: string;
}

export const ProductDetailsDPValeDisplay: FC<Props> = ({ orderId, isElectronicos }) => {
	const openModal = useIsOpen();

	return (
		<Fragment>
			<Box
				sx={{
					display: 'flex',
					flexWrap: 'wrap',
					// flexDirection: 'row',
					alignItems: 'center',
					marginTop: '7px !important',
				}}
			>
				<Stack>
					<Typography sx={tileDescriptionSX}>{'¿Tienes un'}</Typography>
				</Stack>
				<Stack>
					<Img
						src="images/dpvale/dpvale@2x.png"
						alt="DPVale"
						sx={{
							height: '15px',
							marginLeft: '4px',
							maxWidth: '61px',
						}}
					/>
				</Stack>
				<Stack>
					<Typography sx={tileDescriptionSX}>{'? Agrega el producto al '}</Typography>
				</Stack>
				<Stack>
					<Typography sx={tileDescriptionSX}>{' carrito y  '}</Typography>
				</Stack>
				<Stack>
					<Typography sx={tileDescriptionSX}>{' revisa tus '}</Typography>
				</Stack>
				<Stack>
					<Linkable href="" type="inline" sx={linkTitleSX} onClick={openModal.on}>
						{'planes de pago'}
					</Linkable>
				</Stack>
			</Box>
			<ShowByCondition condition={openModal.open}>
				<ProductDetailsDPValeDisplayModal
					isElectronicos={isElectronicos}
					orderId={orderId}
					onClose={openModal.off}
				/>
			</ShowByCondition>
		</Fragment>
	);
};
